<template>
	<v-container fill-height fluid class="pa-0">
		<Tipo />
		<Excluir />
		<Novo />
		<v-row class="ma-0">
			<v-col cols="12" class="pa-0">
				<v-card tile :height="this.$store.getters.alturaContent" cols="12" :loading="loading">
					<v-card-title>
						<v-toolbar flat dense>
						<v-spacer></v-spacer>
							<v-btn color="primary" small @click="criarNovoTipo()">Novo</v-btn>
						</v-toolbar>
					</v-card-title>
					<v-card-text>
						<v-data-table :page.sync="pagina" hide-default-footer :height="this.$store.getters.alturaContent - 170" 
						locale="pt-BR" dense fixed-header class="table-item" :items="tipos" :headers="fields" :items-per-page="itensPorPagina">
							<template v-slot:item.action="{ item }">
								<v-btn icon class="mx-1" color="primary" @click="editar(item)">
									<v-icon>mdi-lead-pencil</v-icon>
								</v-btn>
								<v-btn icon color="primary"  @click="excluir(item)">
									<v-icon>mdi-delete</v-icon>
								</v-btn>
							</template>
						</v-data-table>
						<v-row>
                            <v-col cols=12>
                                <v-pagination :length="totalPaginas" total-visible="7" v-model="pagina">
                                </v-pagination>
                            </v-col>
                        </v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
	import { baseApiUrl, 
	showError, 
	//showSuccess 
	} from "@/config/global"
	import axios from 'axios'
	import Tipo from '@/components/cadastros/tipoAtendimentos/Tipo'
	import Excluir from '@/components/cadastros/tipoAtendimentos/ExcluirTipo'
	import Novo from '@/components/cadastros/tipoAtendimentos/NovoTipo'
	import metodos from '@/mixins/metodos.js'
	import Br from '@/config/barramento.js'

	export default{
		mixins:[metodos],
		components:{Tipo, Excluir, Novo},
		data(){
			return {
				loading: false,
				pagina: 1,
                totalPaginas: 1,
                itensPorPagina: 8,
				tipos: [],
				fields: [
					{value: 'id', text: 'Código', align: 'center'},
					{value: 'descricao', text: 'Descricao', align: 'center'},
					{text: 'Ações', value: 'action', align: 'center', divider: true}
				],

			}
		},
		methods:{
			buscaTipos(){
				this.loading = true
				const url = `${baseApiUrl}/Cadastros/tiposAtendimento/read.php`

				axios.get(url)
						.then(res => {
							if(res.data.codigo == "01"){
								this.tipos = res.data.dados
							}
							this.totalPaginas = Math.ceil(this.tipos.length / this.itensPorPagina)
							this.loading = false
						})
						.catch({showError})
			},

			editar(tipo){
				Br.setEditarTipoAtendimento(tipo)
			},

			criarNovoTipo(){
				Br.setNovoTipoAtendimento()
			},

			excluir(tipo){

				Br.setExcluirTipoAtendimento(tipo)
				
			}

		},

		created(){
			this.buscaTipos()

			Br.onTipoAtendimentoExcluido(tipo => {
					let idx = this.tipos.findIndex((v) => {
                               return v.id == tipo.id
                            })

                            this.tipos.splice(idx, 1)
				})

			Br.onTipoAtendimentoCadastrado(tipo => {
				
				this.tipos.push(tipo)
			})

			Br.onTipoAtendimentoAtualizado(tipo => {
				let idx = this.tipos.findIndex((v) => {
					return v.id == tipo.id
				})

				this.tipos[idx] = tipo
			})

		}
	}
</script>

<style scoped>

</style>